/**
 * Created by yoavp on 1/17/2016.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("content-templates/content-gallery/system/contentSystemAssignSkillsDialogView.tmpl");
    var Button = require("ui/button/Button");
    var Multiselect = require("ui/multiselect/Multiselect");
    var ContentSystemAssignSkillDialogView = {};


    LE.module("LEContent", function (LEContent, LE, Backbone, Marionette, $, _) {
        ContentSystemAssignSkillDialogView = Marionette.Layout.extend({
            className: "assign-skill-container",
            template: template,
            ui: {
                multiSelect: ".assign-skill-multiselect",
                textArea: ".assign-skill-text",
                cancelButton: ".assign-skill-cancel-btn",
                saveButton: ".assign-skill-save-btn",
                assignToSkillIcon: ".icon"
            },
            uiComponents: {
                skillsMultiSelect: {
                    type: Multiselect,
                    options: {
                        container: "view.ui.multiSelect",
                        permutation: Multiselect.PERMUTATION.FULL,
                        trim: true,
                        items: "view._getSkillsArr",
                        floating: false,
                        list: {
                            maxShownItems: 5,
                            newItem: {
                                visible: false
                            }
                        },
                        tagsContainer: {
                            placeholder: LE.translator.translate("LEContent.content.gallery.assignSkills.multiSelect.placeholder"),
                            inlineErrorText: "",
                            maxShownLines: 3
                        }
                    }
                },
                saveButton: {
                    type: Button,
                    options: {
                        el: "view.ui.saveButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY
                    },
                    events: {
                        "click": "_onSaveClick"
                    }
                },
                cancelButton: {
                    type: Button,
                    options: {
                        el: "view.ui.cancelButton",
                        permutation: Button.PERMUTATION.LINK
                    },
                    events: {
                        "click": "_onCancelCLick"
                    }
                }
            },
            events: {
            },

            initialize: function (options) {
                options = options || {};
                this.assignSkills = options.assignSkills || [];
                this.newAssignSkills = options.newAssignSkills || [];
                this.selectedItems = [];
                this._bindEvents();
            },

            _bindEvents: function () {
                this.listenTo(this, "dialog:closeButtonClick", this._onCloseClick);
                this.listenTo(LEContent.getDataManager().getSkillsCollection(), "fetch:success", this._updateSkills);
            },

            _getSkillsArr: function () {
                LEContent.logger.debug("Generating the assignSkill multiselect array", "ContentSystemAssignSkillDialogView:_getSkillsArr");

                var cloneSkillsCollection = LEContent.getDataManager().getSkillsCollection().clone();
                _.each(this.assignSkills, function(value, key, obj) {
                    var deleteModel = cloneSkillsCollection.get(key);
                    cloneSkillsCollection.remove(deleteModel);
                });
                _.each(this.newAssignSkills, function(skillId) {
                    var deleteModel = cloneSkillsCollection.get(skillId);
                    cloneSkillsCollection.remove(deleteModel);
                });
                var skillsMultiselectArr = [];
                cloneSkillsCollection.each(function (skill) {
                    skillsMultiselectArr.push({
                        id: skill.id,
                        value: skill.getName(),
                        selected: false
                    });
                }, this);

                return skillsMultiselectArr;
            },

            _updateSkills: function() {
                var skillsArr = this._getSkillsArr();
                if (this.uiComponents && this.uiComponents.skillsMultiSelect) {
                    this.uiComponents.skillsMultiSelect.setItems(skillsArr);
                }
            },

            _onSaveClick: function () {
                var needToSave = this._updateContentWithSelectedSkills();
                if (needToSave) {
                    LEContent.logger.debug("Saving the assign skill data", "ContentAssignSkillDialogView:_onSaveClick");
                    this.trigger("dialogInnerView:onSaveClick", this.selectedItems);
                } else {
                    LEContent.logger.debug("No data to save", "ContentAssignSkillDialogView:_onSaveClick");
                    this._closeDialog();
                }
            },

            _updateContentWithSelectedSkills: function () {
                var skillsToAdd = this.uiComponents.skillsMultiSelect.getSelectedItems();
                if (skillsToAdd.length === 0) {
                    LEContent.logger.debug("No need to save the data - no changes were made", "ContentAssignSkillDialogView:_updateContentWithSelectedSkills");
                    return false; // No need to save data if no changes were made.
                } else {
                    this.selectedItems = skillsToAdd;
                }
                LEContent.logger.debug("content was updated with the skills", "ContentAssignSkillDialogView:_updateContentWithSelectedSkills");
                return true;
            },

            _onCancelCLick: function () {
                LEContent.logger.debug("dialog innerView cancel button clicked", "ContentAssignSkillDialogView:_onCancelCLick");
                this._closeDialog();
            },

            _onCloseClick: function () {
                LEContent.logger.debug("dialog close button clicked", "ContentAssignSkillDialogView:_onCloseClick");
                this._closeDialog();
            },

            _closeDialog: function () {
                this.trigger("dialogInnerView:closeDialog");
            }
        });
    });

    return ContentSystemAssignSkillDialogView;
});
